/* eslint-disable @nx/enforce-module-boundaries */
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import {
  Text,
  Image,
  HStack,
  Button,
  Flex,
  Card,
  CardBody,
  CardFooter,
  VStack,
} from '@mybridge/ui';
import Link from 'next/link';
import { EventDefaultImage } from '@mybridge/icons/EventDefaultImage';
import {
  EventClockIcon,
  EventHostIcon,
  LocationIcon,
  LinkIcon,
  CalendarIcon,
  AlarmIcon,
  AuthorIcon,
  AuthorIconEvent,
} from '@mybridge/icons';
import { PostBoxContext, usePostBoxContext } from '../context';
import moment from 'moment';
import { getUserFullName, getUserProfilePic } from 'v4/lib/commons';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { setIsSelectedEvent } from 'v4/store/actions/calendar.actions';
import { useRouter } from 'next/router';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import { MyNetworkContext } from 'v4/components/network/context';

export const EventPostBody = ({ fromPublicEvent = false }) => {
  const { post, userProfileInfo, acceptEventLoading, acceptEvent } = useContext(PostBoxContext);
  const router = useRouter();
  const { loggedIn } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const {
    id,
    title,
    author,
    media,
    start_time,
    end_time,
    attendees,
    event_type,
    visibility,
  } = post;

  const attending = attendees?.find?.(
    (a) => a?.user?.id === userProfileInfo?.id
  );

  const handleselectEvents = (event) => {
    !loggedIn && event?.id && dispatch(setIsSelectedEvent(event));
    if(!loggedIn && event?.id){
      router.push(`/g/events/${event?.id}`)
    }else{
      router.push(`/myevents/details/${id}`)
    }
  };
  const { t } = useTranslator();

  // helper functions
  const formatDate = (date, lang = 'en') => {
    try {
      return new Intl.DateTimeFormat(
        !lang || lang == 'undefined' ? 'en' : lang,
        {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
        }
      ).format(new Date(date));
    } catch {
      // fallback if invalid lang
      return new Intl.DateTimeFormat('en', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      }).format(new Date(date));
    }
  };

  const formatTime = (date, lang = 'en') => {
    try {
      return new Intl.DateTimeFormat(
        !lang || lang == 'undefined' ? 'en' : lang,
        {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        }
      ).format(new Date(date));
    } catch {
      // fallback if invalid lang
      return new Intl.DateTimeFormat('en', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      }).format(new Date(date));
    }
  };

  const currentLanguage = useSelector((state) => state.translation.language);

  const { isFriend } = useContext(MyNetworkContext);
  // const isEventPostVisible = useMemo(() => {
  //   if (visibility === 2 || visibility === 1) {
  //     return isFriend(author);
  //   }
  //   return true;
  // }, [visibility, author, isFriend]);

  // if (!isEventPostVisible) {
  //   return null; // Don't render the event post if it's not visible
  // }

  return (
    <>
      <Card
        mb={3}
        border="1px solid #E4E6EB"
        borderRadius="20px"
        ml={
          !fromPublicEvent && !isMobile
            ? '60px'
            : fromPublicEvent
            ? ['0px','15px']
            : '0px'
        }
        width={isMobile ? '100%' : '70%'}
      >
        <CardBody p={0}>
          {media[0]?.file && (
            <Image
              src={media[0].file}
              alt={title}
              maxW="100%" // Ensure the image takes full width of the Card
              borderTopRadius="20px" // Match borderRadius of Card
              objectFit="cover"
              h="225px"
              w="100%"
            />
          )}
          {/* Content Section */}
          <VStack align="flex-start" spacing={2} flex={1} p={4}>
            {' '}
            {/* Add padding for content */}
            {/* <ForceSignInWrapper> */}
              <Text
                // as={Link}
                href={`/myevents/details/${id}`}
                fontWeight="medium"
                color="#3D5A80"
                lineHeight="1.2"
                fontSize="20px"
                cursor="pointer"
                isTruncated
                whiteSpace={'normal'}
                onClick={() => {
                  handleselectEvents(post);
                }}
              >
                {title?.length > 83
                  ? `${title.slice(0, 83)}...`
                  : title || t('createPost.event') || 'Event'}
              </Text>
            {/* </ForceSignInWrapper> */}
            {/* <HStack>
              <CalendarIcon color="#9F9F9F" width="19px" height="17px" />
              <Text fontSize="14px">
                {moment(start_time).local().format('MMM DD, YYYY')}
              </Text>
            </HStack> */}
            {/* <HStack>
              <AlarmIcon color="#9F9F9F" width="19px" height="17px" />
              <Text fontSize="14px">
                {moment(start_time).local().format('hh:mm A')} -{' '}
                {moment(end_time).local().format('hh:mm A')}
              </Text>
            </HStack> */}
            <HStack>
              <CalendarIcon color="#9F9F9F" width="19px" height="17px" />
              <Text fontSize="14px">
                {formatDate(start_time, currentLanguage)}
              </Text>
            </HStack>
            <HStack>
              <AlarmIcon color="#9F9F9F" width="19px" height="17px" />
              <Text fontSize="14px">
                {formatTime(start_time, currentLanguage)} -{' '}
                {formatTime(end_time, currentLanguage)}
              </Text>
            </HStack>
            {(post?.attendee_ids?.includes(userProfileInfo?.id) ||
              post?.attendees?.some?.(attendee => attendee?.user?.id === userProfileInfo?.id) ||
              post?.author?.id === userProfileInfo?.id) &&
              post?.location_type === 'provide' &&
              post?.location?.length > 0 && (
                <HStack>
                  <LocationIcon color={'#9F9F9F'} width="19px" height="17px" />
                  <Text fontSize="14px">{post?.location}</Text>
                </HStack>
              )}
            {(post?.attendee_ids?.includes(userProfileInfo?.id) ||
              post?.attendees?.some?.(attendee => attendee?.user?.id === userProfileInfo?.id) ||
              post?.author?.id === userProfileInfo?.id) && (
              <HStack>
                <LinkIcon color="#9F9F9F" width="19px" height="17px" />
                <Text fontSize="14px" isTruncated>
                  <Link
                    style={{ whiteSpace: 'normal' }}
                    href={`/myevents/details/${id}`}
                  >{`${process.env.BASE_PUBLIC_URL}myevents/details/${id}`}</Link>
                </Text>
              </HStack>
            )}
            <HStack>
              <AuthorIconEvent width="19px" height="17px" />
              <Text fontSize="14px">
                <Link href={`/p/${author?.slug}`}>
                  {getUserFullName(author)}
                </Link>
              </Text>
            </HStack>
          </VStack>
        </CardBody>

        <CardFooter p={4}>
          <ForceSignInWrapper>
            <Flex justify="space-between" align="center">
              {/* RSVP/Register Button */}
              {attending?.status === 'ACCEPT' ||
              post?.attendee_ids?.includes(userProfileInfo?.id) ||
              post?.author?.id === userProfileInfo?.id ? (
                <>
                  {/* {post?.event_status==='LIVE' && <Button
                    size="sm"
                    border="1px solid #00000033"
                    borderRadius="27px"
                    _hover={
                      {cursor: 'default'}
                    }
                    fontSize="12px"
                    color="#5B5B5B"
                    bg="none"
                    mr={2}
                  >
                    {event_type==='webinar'?'Webinar is Live':'Event is Live'}
                  </Button>} */}

                  <Button
                    as={Link}
                    href={`/myevents/details/${id}`}
                    size="sm"
                    border="1px solid #00000033"
                    borderRadius="27px"
                    fontSize="12px"
                    color="#5B5B5B"
                    bg="none"
                  >
                    {t('pageJobs.viewDetails') || 'View Details'}
                  </Button>
                </>
              ) : moment(end_time).isBefore(moment()) && post?.event_status!=='LIVE' ? (
                <Button
                  size="sm"
                  border="1px solid #00000033"
                  borderRadius="27px"
                  fontSize="12px"
                  color="#5B5B5B"
                  bg="none"
                  isDisabled={true}
                >
                  {event_type==='webinar'?'Webinar Ended':(t('pageJobs.EventPassed') || 'Event Ended')}
                </Button>
              ) : userProfileInfo?.id !== author?.id ? ( // other users  
                post?.event_status==='LIVE' ? (
                  <Button
                    size="sm"
                    border="1px solid #00000033"
                    borderRadius="27px"
                    _hover={
                      {cursor: 'default'}
                    }
                    fontSize="12px"
                    color="#5B5B5B"
                    bg="none"
                    mr={2}
                  >
                    {'Running'}
                  </Button>
                ) : (
                  <Button
                    isLoading={acceptEventLoading}
                    onClick={() => acceptEvent(post)}
                    size="sm"
                    border="1px solid #00000033"
                    borderRadius="27px"
                    fontSize="12px"
                    color="#5B5B5B"
                    bg="none"
                  >
                    {event_type === 'general'
                      ? t('signingPage.signUp') || 'Sign Up'
                      : t('eventDashboard.register') || 'Register'}
                  </Button>
                )
            ) : ( //organisers 
                <Button
                  as={Link}
                  href={`/myevents/details/${id}`}
                  size="sm"
                  border="1px solid #00000033"
                  borderRadius="27px"
                  fontSize="12px"
                  color="#5B5B5B"
                  bg="none"
                >
                  {t('pageJobs.viewDetails') || 'View Details'}
                </Button>
              )}
            </Flex>
          </ForceSignInWrapper>
        </CardFooter>
      </Card>
    </>
  );
};
